<template>
  <b-row class="px-2 mt-3">
    <b-col>
      <div class="iq-card">
        <div class="iq-card-header d-flex justify-content-between">
          <div class="iq-header-title">
            <h5 class="card-title">RPM, Fuel Consumption, And Speed Chart</h5>
          </div>
        </div>
        <div class="card-info-container" :class="{ 'card-info-container--center-avg': infoSections.length === 1 }">
          <div class="card-info-section" v-for="section in infoSections" :key="section.key">
            <h5 class="">{{ section.value }}</h5>
            <span class="">{{ section.label }}</span>
          </div>
        </div>

        <div class="rpm-fuel-speed-chart">
          <rpm-fuel-speed
            :series="currAssetSummary.series"
            :deviceStatus="deviceStatus"
          />
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { getRpmTypeLabel } from '../../util/fms-summary';
import RpmFuelSpeed from '../charts/RpmFuelSpeed.vue';

export default {
  name: 'RpmFuelSpeedCard',
  components: {
    RpmFuelSpeed,
  },
  props: {
    currAssetSummary: {
      type: Object,
      required: true,
    },
    deviceStatus: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    infoSections() {
      const sections = [];
      const { fm, rpm, gps } = this.currAssetSummary || {};
      const rpmTypes = this.deviceStatus?.rpmTypes || [];
      if (!fm || !rpm || !gps) return [];

      if (fm.PORT?.in && rpm.PORT) {
        const displayLabel = getRpmTypeLabel('PORT', rpmTypes);
        sections.push({ key: 'port-rpm', label: `Avg. ${displayLabel} RPM`, value: rpm.PORT.average });
        sections.push({ key: 'port-fm', label: `${displayLabel} Fuel Cons`, value: `${fm.PORT.in.engineCons} Liter` });
      }
      if (fm.STARBOARD?.in && rpm.STARBOARD) {
        const displayLabel = getRpmTypeLabel('STARBOARD', rpmTypes);
        sections.push({ key: 'starboard-rpm', label: `Avg. ${displayLabel} RPM`, value: rpm.STARBOARD.average });
        sections.push({ key: 'starboard-fm', label: `${displayLabel} Fuel Cons`, value: `${fm.STARBOARD.in.engineCons} Liter` });
      }
      if (fm.CENTER?.in && rpm.CENTER) {
        const displayLabel = getRpmTypeLabel('CENTER', rpmTypes);
        sections.push({ key: 'center-rpm', label: `Avg. ${displayLabel} RPM`, value: rpm.CENTER.average });
        sections.push({ key: 'center-fm', label: `${displayLabel} Fuel Cons`, value: `${fm.CENTER.in.engineCons} Liter` });
      }

      sections.push({ key: 'avg-speed', label: 'Avg. Speed', value: `${gps.averageSpeed} Knot` });

      return sections;
    },
  },
};
</script>

<style scoped>
.card-info-container {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 10px;
  padding: 10px 15px;
}

.card-info-container--single {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.card-info-container--center-avg {
  grid-template-columns: 1fr;
  justify-items: center;
}

.card-info-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

@media screen and (max-width: 991px) {
  .card-info-container {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-template-rows: auto auto;
  }
}

.rpm-fuel-speed-chart {
  margin: 0 1rem 1rem;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

@media screen and (max-width: 575px) {
  .iq-card-header {
    padding-left: 16px;
    padding-right: 16px;
  }

  .card-title {
    font-size: 1rem;
    line-height: 1.35;
  }

  .card-info-container {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px 8px;
    padding: 8px 12px 12px;
  }

  .card-info-container--center-avg {
    grid-template-columns: 1fr;
  }

  .card-info-section h5 {
    font-size: 1rem;
    margin-bottom: 2px;
  }

  .card-info-section span {
    font-size: 0.75rem;
    line-height: 1.2;
  }

  .rpm-fuel-speed-chart {
    margin: 0 0.75rem 0.75rem;
    padding-bottom: 6px;
  }
}
</style>
